module.exports = __webpack_public_path__ + "static/img/payment-success.298dd26f.png";